import { Fragment } from 'react'

import { splitLinks } from '@/lib/utils/links'

/**
 * Text with its links made clickable.
 *
 * Each link opens in a new tab, so following one never loses the conversation, and with
 * `noopener noreferrer`, so the opened page gets no handle back to this one. A long address
 * wraps anywhere rather than pushing the chat sideways on a phone.
 */
export function LinkedText({ text }: { text: string }) {
  const parts = splitLinks(text)
  if (parts.every((part) => part.type === 'text')) return <>{text}</>

  return (
    <>
      {parts.map((part, index) =>
        part.type === 'text' ? (
          <Fragment key={index}>{part.value}</Fragment>
        ) : (
          <a
            key={index}
            href={part.href}
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-primary-bright underline decoration-primary/40
              underline-offset-2 [overflow-wrap:anywhere] hover:decoration-primary-bright"
          >
            {part.label}
          </a>
        ),
      )}
    </>
  )
}
